module.exports = __webpack_public_path__ + "static/media/kyle.ed2b79c0.png";